import { motion } from "framer-motion";

const STEPS = [
  { n: "01", t: "Pick your poison", d: "Residential or commercial. Standard, deep, move-out, post-construction. Choose your flavor of clean." },
  { n: "02", t: "Pick your time", d: "Live availability. Choose a date and a slot that works. No back-and-forth emails." },
  { n: "03", t: "We go to work", d: "You get a confirmation in your inbox. We do a quick walkthrough, quote your clean, and leave it immaculate. You brag about it later." },
];

export const Process = () => (
  <section id="process" className="relative border-t border-white/10 bg-[#0D0E11]" data-testid="process-section">
    <div className="mx-auto grid max-w-[1400px] gap-14 px-5 py-24 sm:px-8 sm:py-32 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-28">
          <p className="eyebrow mb-6">( How it works )</p>
          <h2 className="font-display text-5xl uppercase leading-[0.9] text-zinc-50 sm:text-7xl">Three steps.<br /><span className="font-serif-i normal-case text-acid">Zero BS.</span></h2>
        </div>
      </div>
      <div className="lg:col-span-8">
        {STEPS.map((s, i) => (
          <motion.div key={s.n} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="group grid grid-cols-[auto_1fr] gap-6 border-b border-white/10 py-10 sm:gap-12" data-testid={`process-step-${s.n}`}>
            <span className="font-display text-6xl text-zinc-700 transition-colors duration-500 group-hover:text-[var(--acid)] sm:text-8xl">{s.n}</span>
            <div className="pt-2">
              <h3 className="text-2xl font-bold tracking-tight text-zinc-50 sm:text-3xl">{s.t}</h3>
              <p className="mt-3 max-w-lg text-zinc-400">{s.d}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
